import styled, { css } from "styled-components";
import { pageGutterSpace } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import { ShowMoreContainer } from "../../organisms/ExpandableContentOrg";
import { borderRadiusOnBiggerScreen, borderWidthOnBiggerScreen, biggerScreenBreakpoint, tableBackgroundOnMobile, borderEmphasis } from "./common";
export var Wrapper = styled.div.withConfig({
  componentId: "sc-1mn77gv-0"
})(["overflow-x:auto;", "{margin:0 ", ";}", "{padding-right:", ";padding-bottom:", ";padding-left:", ";}"], breakpoint("small", biggerScreenBreakpoint), space(-1 * pageGutterSpace), ShowMoreContainer, space(pageGutterSpace), space(2), space(pageGutterSpace));

/**
 * 1. Forces cells to not expand themselves when they have a too big content
 * */
export var Table = styled.div.withConfig({
  componentId: "sc-1mn77gv-1"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    $isHeaderSticky = _ref.$isHeaderSticky,
    $headerHeight = _ref.$headerHeight,
    $minWidth = _ref.$minWidth,
    $hasFullWidthHeader = _ref.$hasFullWidthHeader,
    theme = _ref.theme;
  return css(["display:flex;flex-flow:column nowrap;min-width:", ";background:", ";p,span{overflow:hidden;text-overflow:ellipsis;}", " ", " ", "{padding:", ";overflow:hidden;border-radius:", ";background:", ";box-shadow:", ";}"], $minWidth && unit($minWidth), getColor(theme, tableBackgroundOnMobile), $hasFullWidthHeader && css(["thead tr{grid-template-columns:none;}"]), $isHeaderSticky && css(["padding-top:", " !important;"], unit($headerHeight)), breakpoint(biggerScreenBreakpoint), unit(borderWidthOnBiggerScreen), getBorderRadius(theme, borderRadiusOnBiggerScreen), getBorderColor(theme, $onColor, borderEmphasis), getBoxShadow(theme, "small"));
});